import _defineProperty from "@babel/runtime/helpers/defineProperty";
export const Environment = {
  isServer: () => typeof window === 'undefined'
};
class WixServerModel {
  constructor() {
    _defineProperty(this, "wixServerParams", void 0);
    this.wixServerParams = this.init();
  }
  init() {
    if (Environment.isServer()) {
      return {};
    }
    try {
      const wixServerDataElement = document.querySelector('#WIX_SERVER_DATA');
      return JSON.parse((wixServerDataElement == null ? void 0 : wixServerDataElement.textContent) || '{}');
    } catch (err) {
      console.error(`Wix Server Params failed to initialize`, err);
      return {};
    }
  }
  get() {
    return this.wixServerParams;
  }
}
export const wixServerData = new WixServerModel();
//# sourceMappingURL=wixServerData.js.map